import { render, staticRenderFns } from "./AddPhotoalbumPage.vue?vue&type=template&id=f4a2050a&scoped=true&"
import script from "./AddPhotoalbumPage.vue?vue&type=script&lang=js&"
export * from "./AddPhotoalbumPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotoalbumPage.vue?vue&type=style&index=0&id=f4a2050a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a2050a",
  null
  
)

export default component.exports